exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".DraftNotifier-draftToast-35-qu {\n  position: fixed;\n  text-align: right;\n  top: 20px;\n  right: 20px;\n  background: #a9d8ea;\n  color: black;\n  padding: 12px 18px;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n  z-index: 9999;\n}", "", {"version":3,"sources":["/usr/src/app/src/components/DraftManagement/DraftNotifier.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;CACf","file":"DraftNotifier.css","sourcesContent":[".draftToast {\n  position: fixed;\n  text-align: right;\n  top: 20px;\n  right: 20px;\n  background: #a9d8ea;\n  color: black;\n  padding: 12px 18px;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n  z-index: 9999;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"draftToast": "DraftNotifier-draftToast-35-qu"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"importLoaders":1,"sourceMap":true,"modules":true,"localIdentName":"[name]-[local]-[hash:base64:5]","minimize":false,"discardComments":{"removeAll":true}}!../~/postcss-loader?pack=default!./components/DraftManagement/DraftNotifier.css
// module id = 1093
// module chunks = 0